import CanvasLabelLinker from "../output/labels/canvas-label-linker.js";

class DomCanvasLabelLinker extends CanvasLabelLinker {
    constructor(domElement) {
        super();

        this._domElement = domElement;
    }

    link(label) {
        const { domElement } = label;
        this._domElement.appendChild(domElement);
    }

    unlink(label) {
        const { domElement } = label;
        this._domElement.removeChild(domElement);
    }
}

export default DomCanvasLabelLinker;
